
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired26f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired26f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5opja", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $3ed2d34eea96e058$export$6503ec6e8aabbaf; }, function (v) { return $3ed2d34eea96e058$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $3ed2d34eea96e058$export$f7ad0328861e2f03; }, function (v) { return $3ed2d34eea96e058$export$f7ad0328861e2f03 = v; });
var $3ed2d34eea96e058$export$6503ec6e8aabbaf;
var $3ed2d34eea96e058$export$f7ad0328861e2f03;
"use strict";
var $3ed2d34eea96e058$var$mapping = new Map();
function $3ed2d34eea96e058$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$3ed2d34eea96e058$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $3ed2d34eea96e058$var$resolve(id) {
    var resolved = $3ed2d34eea96e058$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$3ed2d34eea96e058$export$6503ec6e8aabbaf = $3ed2d34eea96e058$var$register;
$3ed2d34eea96e058$export$f7ad0328861e2f03 = $3ed2d34eea96e058$var$resolve;

});

var $9f4a35ce2f992109$exports = {};

(parcelRequire("5opja")).register(new URL("", import.meta.url).toString(), JSON.parse('["2lyl3","index.51a18b73.js","amtmr","karkhana-logo-1.f6ab47f3.png","h1tfW","k.1879a8e4.svg","ibdEo","web.ee44c951.js","2Ejfx","Kkonnect.eeb7b9e0.png","11PNI","k.1879a8e4.svg","gu4AW","NoFilesAdded.754048ce.png","jjmat","Extend.d42449d0.png","loNex","Submit.1d6e2787.png","bFImg","parts.5566edc6.svg","2YnaF","RejectRfq.1609c182.png","cSyNA","AcceptRfq.dd0e640e.png","fkucy","capability.11ae402d.svg","95I3d","CancelQuote.a71e79fb.png","aXOPU","dfAdIcon1.2e837935.png","bTxGE","dfAdIcon2.e0f67c64.png","Xur24","dfAdIcon3.5c9d917e.png","2frrk","Supplier_Profile_Page_Home.05feae9b.png","fr9SM","Supplier_profile_mobile_page.d38fa86b.png","eTbFv","fileUploadIcon.17d0a8ef.png","2HOeM","Write.50c1b7df.png","2AeLQ","pdf.8950c641.svg","jl02m","doc.10ea4917.svg","7bd7P","Trash.f0c1d1ee.png","cly4c","Delete.d5c698ec.png","ktatb","productsImage1.02cf4a62.png","eEz2q","productsImage2.a6390837.png","cwlOL","productsImage3.fdf16b00.png","a20mp","cartSupplier.cd3d7b39.svg","fybU0","calculate.a14afff4.svg","3rdib","quote.3d215922.svg","icPv6","openRFQ.78ba337e.svg","1B7QA","liveOrder.db0e8757.svg","8EwJS","recentActivities.b4446cab.svg","kbIox","DashboardEqualizer.d4eab07e.svg","7elwk","dashboardDigitalFactory.c5a90af7.svg","iJQag","SupplierProfile.6fb752d1.svg","cFOan","whatsApp.bc1d1132.svg","a1Al6","linkedin.3de15a30.svg","8OglI","gmail.dd7da3d0.svg","6yCmS","InviteSent.297a479f.svg","2S8Ue","Mapmarker.d0ff0d35.svg","lH85j","EmailDuotone.b2b48d45.svg","ecuaj","uploadComplete.8f024808.svg","h1DlW","UploadNDA.24ef9424.js","8r1Og","completed.1b831b5b.svg","b1hAx","NoUpdates.fc59605b.png","67A4u","Login.92d0f38f.js","8kVSB","Register.5f299574.js","bA7DZ","kio-mob.05a739dc.svg","c1gIY","ob2.29eaeddf.svg","lRfbX","ob3.9382aabc.svg","4wmrZ","ob4.6262ef8f.svg","dCj2G","ob5.12d3888c.svg","5QJX7","Register.c79b46c4.css","lIrMy","Register.d6872572.css","hegCB","Home.d376d124.js","hoPM7","Home.18e6a526.js","hNKE0","Home.8831a788.css","kP8Xw","RfqMainTable.781fec9e.js","9q5s5","Quotes.8f7a8474.js","fviu2","quotesZero.b643bfed.svg","8DbYL","Orders.6f5b733c.js","ehuLz","DigitalFactoryHome.3e4d13e0.js","fWnIm","DigitalFactory.28249b33.js","g0x5f","CompanyOverView.eca1703e.js","ce6vH","BasicDetails.b92763bf.js","iqLCx","DeleteFile.794075d1.js","5qv6o","FileViewer.27fefd5c.js","i3f0f","BasicDetails.9667cc7e.js","6gP1P","AddressAndContacts.48e034ee.js","iuzEp","AddEditAddress.866c9b5c.js","8lVnB","AddEditContact.08759679.js","59Njd","RegistrationDetails.891c6047.js","5LMBv","AdditionalInformation.5c294fb0.js","eBlLH","AddEditCustomer.06d9078a.js","iP49l","AddEditProject.b8d75af6.js","8cQkY","ViewProject.015bda2e.js","2WaMD","AdditionalInformation.ffb55dd6.js","ltmAV","Products.d385b5dc.js","ivKdX","ViewProduct.b3ffc480.js","h1DyG","AddEditProduct.ff7aa3de.js","k8mii","Services.f1575c61.js","7VpJo","ManufacturingProcess.543a15f3.js","7FaDh","MaterialCapabilities.fb3472b0.js","1Zd1k","FinishingCapabilities.ce5d5e69.js","jQfKC","DesignServices.9b78321b.js","2iVtT","Machines.8db2767c.js","b0TTY","machines1.8f20c7fb.png","iPNfv","machines2.755b009d.png","kebwk","machines3.4dbd1e43.png","33mSw","Completed.94746ace.js","lWZeW","Kkonnect_logo.c0797647.png","d0J8Z","VerifyEmail.108f6076.js","rXn9B","loader.06017003.gif","5TdeS","publicIcon1.0d44aefd.svg","avsNk","publicIcon2.b84d66ce.svg","11Ul3","publicIcon3.85c62222.svg","btuem","publicIcon4.bfb0c595.svg","3INoD","publicIcon5.9447ccd6.svg","2kTQR","kio-mob.50169c59.png","aNvDZ","SupplierLogo.035482f8.png","15Ext","NotFound.c1ec3d4d.js","c8ozu","404.7103a15f.png"]'));


//# sourceMappingURL=index.runtime.e5568ced.js.map
